<template>
  <article class="ticket">
    <div class="ticketTop" @click="openLoungeDetails">
      <div class="ticketTopLeft">
        <h5 style="width: 100%">
          {{ lounge.title }}
        </h5>
      </div>
      <div class="ticketTopRight">
        <img :src="config.projectURL + 'assets/images/lounges/'+lounge.image+'.jpg'" v-if="lounge.image">
        <img :src="config.projectURL + 'assets/images/events/'+lounge.eventImage+'.jpg'" v-else>
        <img :id="'miniQRCode'+lounge.id" class="miniQRCode" v-if="!openDetails">
      </div>
    </div>
    <div class="pad-16 grid-12 ticketBottom">
      <div class="col-sp-8 row-sp-12">
        <h6 v-html="nl2br(lounge.description)" />
      </div>
    </div>
    <div v-if="openDetails" class="ticketDetails">
      <div class="pad-16 t-center">
        <div>
          <img :id="'QRCode'+lounge.id" class="pad-16 br-10 bgcolor-white">
        </div>
        <h4>{{ lounge.secureCode }}</h4>
      </div>
    </div>
  </article>
</template>

<script>
import {authStore} from "@/store/authStore";
import {userStore} from "@/store/userStore";
import {configStore} from "@/store/configStore";
import Qrious from "qrious";
import {nl2br} from "@/modules/main";

export default {
  name: "loungeSingle",
  props: ["lounge"],
  setup(){
    const auth = authStore()
    const config = configStore()
    const user = userStore()

    return {auth, config, user}
  },
  data() {
    return {
      openDetails: false,
      friends: null
    }
  },
  mounted() {
    this.config.loading = false
    this.loadMiniQRCode()
  },
  methods: {
    loadMiniQRCode() {
      this.$nextTick(() => {
        new Qrious({
          element: document.getElementById('miniQRCode'+this.lounge.id),
          size: 60,
          value: this.lounge.secureCode,
          background: '#ffffff',
          foreground: '#000000',
          level: 'H',
        });
      });
    },
    openLoungeDetails() {
      if(this.openDetails){
        this.openDetails = false;
        this.loadMiniQRCode()
      }else{
        this.openDetails = true;
        this.$nextTick(() => {
          new Qrious({
            element: document.getElementById('QRCode'+this.lounge.id),
            size: 250,
            value: this.lounge.secureCode,
            background: '#ffffff',
            foreground: '#000000',
            level: 'H',
          });
        });
      }
    },
    nl2br(str){
      return nl2br(str)
    }
  }
}
</script>

<style scoped>
.ticket{
  background-color: var(--second-bg-color);
  border-radius: 10px;
  margin-bottom: 32px;
}
.ticket .ticketTop{
  position: relative;
  cursor: pointer;
  margin-bottom: -24px;
}
.ticket .ticketTop .ticketTopLeft {
  background-color: #ffffff;
  display: inline-block;
  max-width: 48px;
  height: calc(100% - 8px);
  position: absolute;
  left: 0;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
  border: 2px solid #ffffff;
}
.ticket .ticketTop .ticketTopLeft h5{
  color: #000000;
  display: block;
  height: 100%;
  padding: 0 16px;
  text-align: center;
  font-weight: 800;
  writing-mode: vertical-lr;
}
.ticket .ticketTop .ticketTopRight{
  display: inline-block;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
  border: 2px solid #ffffff;
  max-width: calc(100% - 54px);
  margin-left: 50px;
}
.ticket .ticketTop .ticketTopRight img:not(.miniQRCode){
  width: 100%;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
  float: right;
}
.ticket .ticketTop .ticketTopRight img.miniQRCode{
  position: absolute;
  bottom: 24px;
  right: 24px;
  border-radius: 10px;
  background: #ffffff;
  padding: 4px;
}
.ticket .ticketBottom{
  padding-top: 40px!important;
}
.ticket .ticketBottom h5{
  font-weight: 800;
  font-size: 1.2em;
  color: #ffffff;
}
.ticket .ticketBottom h6{
  font-weight: 200;
  font-size: 1em;
  margin-bottom: 8px;
  color: rgba(255,255,255,0.6);
}
.ticket .ticketDetails h4{
  font-weight: 800;
  font-size: 1.2em;
  margin-top: 24px;
  margin-bottom: 8px;
}
.friendItem{
  display: inline;
  margin-left: -14px;
}
.friendItem img{
  border: 1px solid #ffffff;
}
</style>